import { YStack } from '@/components/ui/layout/layout';
import {
  handleContactsConnect,
  handleOpenContactsSettings,
} from '@/integrations/integration-handlers';
import { useContactsState } from '@/integrations/useContactsState';

import { DevicePermissionBanner } from './device-permission-banner';

import type { ConfigurationContext } from './configuration.types';

export function ContactsAccessConfiguration(_props: {
  context: ConfigurationContext;
}) {
  const { contactsStatus } = useContactsState();

  return (
    <YStack className="gap-4 p-6">
      <DevicePermissionBanner
        status={contactsStatus}
        domain="Contacts"
        domainPlural="contacts"
        onGrantAccess={handleContactsConnect}
        onOpenSettings={handleOpenContactsSettings}
      />
    </YStack>
  );
}
